import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  Grid,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  Button as MuiButton,
  Divider,
  TextField as MuiTextField,
  // Alert as MuiAlert,
} from "@mui/material";
import axios from "axios";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";

const Card = styled(MuiCard)(spacing);
// const Alert = styled(MuiAlert)(spacing);
const TextField = styled(MuiTextField)(spacing);
const Button = styled(MuiButton)(spacing);

const validationSchema = Yup.object().shape({
  shortCode: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
});

export default function ViewClaimStateDialog(props) {
  const { viewClaimStateDialog, setViewClaimStateDialog, refreshTable } = props;

  const initialValues = {
    claimStateId: viewClaimStateDialog?.params?.claimStateId,
    shortCode: viewClaimStateDialog?.params?.shortCode,
    description: viewClaimStateDialog?.params?.description,
  };

  const handleSubmit = async (values) => {
    try {
      const updatedClaimState = {
        shortCode: values.shortCode,
        description: values.description,
      };

      axios
        .put("/api/v1/claimStates/" + values.claimStateId, updatedClaimState)
        .then((response) => {
          // console.log("Your data has been submitted successfully!");
          refreshTable();
        })
        .catch(function (error) {
          console.error("Error: ", error);
        });
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  return (
    <Dialog
      open={viewClaimStateDialog.isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {viewClaimStateDialog.title}
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values,
            status,
          }) => (
            <Card mb={6}>
              <CardContent>
                {/* {submitInError ? (
                  <Alert severity="error" my={3}>
                    {errorMessage}
                  </Alert>
                ) : errorMessage.length > 0 ? (
                  <Alert severity="success" my={3}>
                    Your data has been submitted successfully!
                  </Alert>
                ) : (
                  ""
                )} */}

                {isSubmitting ? (
                  <Box display="flex" justifyContent="center" my={20} mx={40}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={6}>
                      <TextField
                        name="claimStateId"
                        label="claimStateId"
                        value={values.claimStateId}
                        type="hidden"
                      />
                      <Grid item md={6} xs={12}>
                        <TextField
                          name="shortCode"
                          label="Short Code"
                          value={values.shortCode}
                          error={Boolean(touched.shortCode && errors.shortCode)}
                          fullWidth
                          helperText={touched.shortCode && errors.shortCode}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="shortCode"
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={6}>
                      <Grid item md={12} xs={12}>
                        <TextField
                          name="description"
                          label="Description"
                          value={values.description}
                          error={Boolean(
                            touched.description && errors.description
                          )}
                          fullWidth
                          helperText={touched.description && errors.description}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          type="description"
                          variant="outlined"
                          my={2}
                        />
                      </Grid>
                    </Grid>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      mt={3}
                      my={2}
                      mr={4}
                      onClick={viewClaimStateDialog.onConfirm}
                    >
                      Change Claim State
                    </Button>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      mt={3}
                      my={2}
                      onClick={() =>
                        setViewClaimStateDialog({
                          ...viewClaimStateDialog,
                          isOpen: false,
                        })
                      }
                    >
                      Close
                    </Button>
                  </form>
                )}
              </CardContent>
            </Card>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
}
